import { CopyButton, Center } from '@sequencehq/core-components'
import { Currency } from '@sequencehq/api'
import { PriceEditorTier, PriceEditorPercentageTier } from '../../../domain'
import { pricingTableToTsv } from '../../../utils'

type CopyPricingTableButtonProps = {
  data:
    | {
        tiers: PriceEditorTier[]
        currency: Currency
      }
    | {
        percentageTiers: PriceEditorPercentageTier[]
        currency: Currency
        isGraduated?: boolean
        includeLimits?: boolean
      }
  'data-testid'?: string
}

export const CopyPricingTableButton = ({
  data,
  'data-testid': dataTestId
}: CopyPricingTableButtonProps) => {
  // Create TSV data for the CopyButton component
  const getTsvData = () => {
    return pricingTableToTsv(data)
  }

  return (
    <Center height="24px" data-testid={dataTestId}>
      <CopyButton value={getTsvData()} enableGroupHover={false} />
    </Center>
  )
}
